import { Component, Input } from '@angular/core';
import { isForeignToForeignCurrencyPair } from '../../utils/foreign-currency-pair';

@Component({
  selector: 'app-foreign-pair-notice',
  templateUrl: './foreign-pair-notice.component.html',
  styleUrls: ['./foreign-pair-notice.component.scss'],
})
export class ForeignPairNoticeComponent {
  @Input() currencyFromCode: string | null | undefined;
  @Input() currencyToCode: string | null | undefined;

  get show(): boolean {
    return isForeignToForeignCurrencyPair(
      this.currencyFromCode,
      this.currencyToCode,
    );
  }
}
